var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRwBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 23",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.1011H21M4.33333 18.7678V9.87891M8.77778 18.7678V9.87891M13.2222 18.7678V9.87891M17.6667 18.7678V9.87891M19.8889 6.54557L11.4711 1.28446C11.3002 1.17764 11.2147 1.12424 11.1231 1.10341C11.0421 1.085 10.9579 1.085 10.8769 1.10341C10.7853 1.12424 10.6998 1.17764 10.5289 1.28446L2.11111 6.54557H19.8889Z",
    stroke: "url(#paint0_linear_1226_2227)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1226_2227",
    x1: 16.4995,
    y1: 9.49927,
    x2: 5.99983,
    y2: 16.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwBusiness);
export default __webpack_public_path__ + "static/media/RWBusiness.e64f43deee259208014bb08c5ec23a4f.svg";
export { ForwardRef as ReactComponent };